import React from "react";
import { pairingResults } from "src/modules/pairing/constants";
import { Message } from "src/modules/communication-protobuf";
import * as selectors from "../duck/selectors";

import RejectionDialog from "../components/RejectionDialog";
import FailureDialog from "../components/FailureDialog";
import RequesterContext from "./Context";
import { store } from "src/store/store";

export default class PairingRequester extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      providing: {
        sendRequestMessage: this.sendRequestMessage
      }
    };
  }

  componentDidMount = () => {
    this.initiate();
  };

  initiate = () => {
    const { messenger } = this.props;
    messenger.on("requestPairingResponseMessage", (response, from) => {
      const { receivedResponse, request } = this.props;

      if (request === null || request.requestId !== response.requestId) {
        return;
      }
      receivedResponse(response);
    });
  };

  sendRequestMessage = (params = {}) => {
    const { messenger, deviceName, familyName } = this.props;

    const pairingSource = selectors.getPairingSource(store.getState());
    const responder = selectors.getResponder(store.getState());
    const request = selectors.getRequest(store.getState());

    if (params.requestId == null && request == null) return;

    const message = Message.RequestPairingMessage.create({
      familyName: params.familyName || familyName,
      pairingSource: params.pairingSource || pairingSource,
      requestId: params.requestId || request.requestId,
      pairingType: params.pairingType || request.pairingType,
      securityCode: params.securityCode || responder.code,
      deviceName: params.deviceName || deviceName,
      authId: params.otpData ? params.otpData.authId : undefined,
      otp: params.otpData ? params.otpData.otp : undefined
    });

    return messenger.sendAsEnvelope({
      to: params.to || responder.jid,
      payload: { message }
    });
  };

  render() {
    const { response, error } = this.props;

    let failureDialog = null;
    if (error || (response && response.result === pairingResults.FAILED)) {
      failureDialog = <FailureDialog />;
    }

    let rejectionDialog = null;
    if (response) {
      const wasRejected =
        response.result === pairingResults.REJECTED ||
        response.result === pairingResults.PAIRING_IN_PROGRESS ||
        response.result === pairingResults.EXCEEDED_DEVICE_LIMIT;
      rejectionDialog = wasRejected ? (
        <RejectionDialog
          exceededDeviceLimit={
            response.result === pairingResults.EXCEEDED_DEVICE_LIMIT
          }
        />
      ) : null;
    }

    return (
      <RequesterContext.Provider value={this.state.providing}>
        {failureDialog || rejectionDialog}
        {this.props.children}
      </RequesterContext.Provider>
    );
  }
}
